import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import InvoiceList from "../pages/invoices/InvoiceList";
import InvoiceDetail from "../pages/invoices/InvoiceDetail";

const InvoiceRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/invoices/`} element={<InvoiceList />} />
      <Route
        path={`${HomePageURL}/invoices/:invoiceId/`}
        element={<InvoiceDetail />}
      />
    </Routes>
  );
};

export default InvoiceRoute;
